/**
 * /admin/usage — the model & token-usage console. One page, two jobs:
 * switch the globally-active provider/model (hidden from end users) and
 * watch per-user + system-wide token consumption. Admin, internal or the
 * Company Settings role via the /admin RequireAdminRoute wrapper; the RPCs
 * are the authoritative gate. The model card is admin/internal only — the
 * model settings RPCs answer nobody else (SAD-948).
 */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { useTenantAreas } from '../../../lib/access/useTenantAreas';
import { useUsageSummary } from './hooks';
import { ModelSettingsCard } from './ModelSettingsCard';
import { UsageChart } from './UsageChart';
import { UsageKpis } from './UsageKpis';
import { UserUsageTable } from './UserUsageTable';
const RANGE_LABELS = {
    '24h': 'Last 24 hours',
    '7d': 'Last 7 days',
    '30d': 'Last 30 days'
};
export function UsagePage() {
    const [range, setRange] = useState('7d');
    const { data: summary, isLoading } = useUsageSummary(range);
    const areas = useTenantAreas();
    const showModel = areas.isAdmin || areas.isInternal;
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-6",
        "data-testid": Testids.adminUsage.page,
        children: [
            /*#__PURE__*/ _jsxs("header", {
                className: "flex items-center justify-between gap-4",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "text-xl font-semibold",
                                children: "Model & usage"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-sm text-muted-foreground",
                                children: "Set the model every chat runs on and track token consumption per user and system-wide."
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Select, {
                        value: range,
                        onValueChange: (v)=>setRange(v),
                        children: [
                            /*#__PURE__*/ _jsx(SelectTrigger, {
                                className: "w-44",
                                "data-testid": Testids.adminUsage.rangeSelect,
                                children: /*#__PURE__*/ _jsx(SelectValue, {})
                            }),
                            /*#__PURE__*/ _jsx(SelectContent, {
                                children: Object.keys(RANGE_LABELS).map((r)=>/*#__PURE__*/ _jsx(SelectItem, {
                                        value: r,
                                        children: RANGE_LABELS[r]
                                    }, r))
                            })
                        ]
                    })
                ]
            }),
            showModel && /*#__PURE__*/ _jsx(ModelSettingsCard, {}),
            /*#__PURE__*/ _jsx(UsageKpis, {
                summary: summary,
                isLoading: isLoading
            }),
            /*#__PURE__*/ _jsx(UsageChart, {
                days: summary?.days ?? []
            }),
            /*#__PURE__*/ _jsx(UserUsageTable, {
                range: range
            })
        ]
    });
}
